const FinalPass = {
  uniforms: {
    iTime: { value: 0 },
    tDiffuse: { value: null },
    torusTexture: { value: null },
    bloomTexture: { value: null },
    haloTexture: { value: null }
  },
  vertexShader: `
    varying vec2 vUv;
		void main()	{
  			vUv = uv;
  			gl_Position = vec4( position, 1.0 );
		}`,
  fragmentShader: `
    uniform float iTime;
    uniform sampler2D tDiffuse;
    uniform sampler2D bloomTexture;
    uniform sampler2D torusTexture;
    uniform sampler2D haloTexture;
    varying vec2 vUv;

    vec3 warp3d(vec3 pos, float t) {
      float curv =.8, a = 1.9, b = 0.7;
      pos *= 2.;
      pos.x += curv * sin(t + a * pos.y) + t * b;
      pos.y += curv * cos(t + a * pos.x);
      pos.y += curv * sin(t + a * pos.z) + t * b;
      pos.z += curv * cos(t + a * pos.y);
      pos.z += curv * sin(t + a * pos.x) + t * b;
      pos.x += curv * cos(t + a * pos.z);
      return 0.5 + 0.5 * cos(pos.xyz + vec3(1,2,4));
    }
    
    void main() {
      vec2 uv = 2. * vUv - 1.;
      vec3 w = pow(warp3d(vec3(uv.x, sin(uv.y), uv.y), iTime * 1.5), vec3(1.5));
      vec3 col = 1.5 * vec3(.05, .75, .5) * w.x;
      col *= w.y;
      col += vec3(0., .12, .2) * w.z;
      col *= smoothstep(0.6, 1., abs(uv.y));
      col *= smoothstep(-.5, 1., -uv.y*uv.x);
      col *= smoothstep(-.5, 1., -uv.y*uv.x);
      gl_FragColor = vec4(col + texture2D(bloomTexture, vUv).xyz + texture2D(torusTexture, vUv).xyz + texture2D(tDiffuse, vUv).xyz + texture2D(haloTexture, vUv).xyz, 1.);
    }`
}

export { FinalPass };